import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shell/shell.component').then((m) => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/pages/dashboard-page.component').then((m) => m.DashboardPageComponent)
      },
      {
        path: 'categories',
        loadComponent: () => import('./features/categories/pages/category-list-page.component').then((m) => m.CategoryListPageComponent)
      },
      {
        path: 'tasks',
        loadComponent: () => import('./features/tasks/pages/task-list-page.component').then((m) => m.TaskListPageComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/pages/user-list-page.component').then((m) => m.UserListPageComponent)
      },
      {
        path: 'evaluations',
        loadComponent: () => import('./features/evaluations/pages/evaluation-page.component').then((m) => m.EvaluationPageComponent)
      },
      {
        path: 'admin',
        loadComponent: () => import('./features/admin/pages/admin-page.component').then((m) => m.AdminPageComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];